module.exports = __webpack_public_path__ + "img/img0.9f435476.jpg";